module.exports = __webpack_public_path__ + "static/media/taco.4be7b986.svg";